import type { Observable } from 'rxjs';
import type { RegistrationValidationResult } from '../models/registration-validation.model';

export abstract class RegistrationValidationPort {
  abstract validateCedula(params: {
    cedula: string;
    tipoDocumento: string;
    idComercio?: number;
  }): Observable<RegistrationValidationResult>;
}
